import { useEffect, useState } from 'react';
import type { PageExperienceFragment } from '@/features/experiences/fragments/PageExperience.generated';
import { getPublishedLink } from '@/features/experiences/lib/publish';
import { useAnalytics } from '@/hooks/useAnalytics';
import { Button, Tooltip, type ButtonProps } from '@/ui';

type Props = ButtonProps & {
  experience: PageExperienceFragment;
};

export const CopyLinkButton = ({ experience, ...props }: Props) => {
  const { trackEvent } = useAnalytics();
  const [showTooltip, setShowTooltip] = useState(false);

  const shareLink = getPublishedLink(experience);

  const handleCopyClick = () => {
    trackEvent('experience:click nav-share-link');

    if (shareLink) {
      navigator.clipboard.writeText(shareLink);
      setShowTooltip(true);
    }
  };

  useEffect(() => {
    if (showTooltip) {
      const timerId = setTimeout(() => setShowTooltip(false), 2000);
      return () => clearTimeout(timerId);
    }
  }, [showTooltip]);

  if (!shareLink) {
    return null;
  }

  return (
    <Tooltip
      hasArrow
      isOpen={showTooltip}
      label="Link copied!"
      offset={[0, 12]}
      variant="purple"
    >
      <Button fontWeight="bold" onClick={handleCopyClick} {...props}>
        Copy
      </Button>
    </Tooltip>
  );
};
